"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _event = require("@vx/event");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Drag = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Drag, _React$Component);

  function Drag() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      x: undefined,
      y: undefined,
      dx: 0,
      dy: 0,
      isDragging: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (event) {
      var _this$props = _this.props,
          onDragStart = _this$props.onDragStart,
          resetOnStart = _this$props.resetOnStart;
      event.persist();

      _this.setState(function (_ref) {
        var dx = _ref.dx,
            dy = _ref.dy;
        var point = (0, _event.localPoint)(event) || {
          x: 0,
          y: 0
        };
        return {
          isDragging: true,
          dx: resetOnStart ? 0 : dx,
          dy: resetOnStart ? 0 : dy,
          x: resetOnStart ? point.x : point.x - dx,
          y: resetOnStart ? point.y : point.y - dy
        };
      }, onDragStart && function () {
        onDragStart(_extends({}, _this.state, {
          event: event
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragMove", function (event) {
      var onDragMove = _this.props.onDragMove;
      event.persist();

      _this.setState(function (_ref2) {
        var x = _ref2.x,
            y = _ref2.y,
            isDragging = _ref2.isDragging;
        var point = (0, _event.localPoint)(event) || {
          x: 0,
          y: 0
        };
        return isDragging ? {
          isDragging: true,
          dx: point.x - (x || 0),
          dy: point.y - (y || 0)
        } : null;
      }, onDragMove && function () {
        if (_this.state.isDragging) onDragMove(_extends({}, _this.state, {
          event: event
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function (event) {
      var onDragEnd = _this.props.onDragEnd;
      event.persist();

      _this.setState({
        isDragging: false
      }, onDragEnd && function () {
        onDragEnd(_extends({}, _this.state, {
          event: event
        }));
      });
    });

    return _this;
  }

  var _proto = Drag.prototype;

  _proto.render = function render() {
    var _this$state = this.state,
        x = _this$state.x,
        y = _this$state.y,
        dx = _this$state.dx,
        dy = _this$state.dy,
        isDragging = _this$state.isDragging;
    var _this$props2 = this.props,
        children = _this$props2.children,
        width = _this$props2.width,
        height = _this$props2.height,
        captureDragArea = _this$props2.captureDragArea;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isDragging && captureDragArea && /*#__PURE__*/_react.default.createElement("rect", {
      width: width,
      height: height,
      onMouseMove: this.handleDragMove,
      onMouseUp: this.handleDragEnd,
      fill: "transparent"
    }), children({
      x: x,
      y: y,
      dx: dx,
      dy: dy,
      isDragging: isDragging,
      dragEnd: this.handleDragEnd,
      dragMove: this.handleDragMove,
      dragStart: this.handleDragStart
    }));
  };

  return Drag;
}(_react.default.Component);

exports.default = Drag;

_defineProperty(Drag, "propTypes", {
  children: _propTypes.default.func.isRequired,
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  captureDragArea: _propTypes.default.bool,
  resetOnStart: _propTypes.default.bool,
  onDragEnd: _propTypes.default.func,
  onDragMove: _propTypes.default.func,
  onDragStart: _propTypes.default.func
});

_defineProperty(Drag, "defaultProps", {
  captureDragArea: true,
  resetOnStart: false
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/brush/node_modules/@vx/drag/lib/Drag.js
// module id = 135
// module chunks = 0